"use client";

import dynamic from "next/dynamic";

const RouteMapInner = dynamic(() => import("./route-map-inner"), {
  ssr: false,
  loading: () => (
    <div className="h-full w-full rounded-md bg-muted animate-pulse" />
  ),
});

type RouteMapProps = {
  positions: [number, number][];
};

export function RouteMap({ positions }: RouteMapProps) {
  if (positions.length === 0) return null;
  return <RouteMapInner positions={positions} />;
}
